import { PageHero } from "../components/common/PageHero";
import { ManpowerSolutions } from "../components/sections/ManpowerSolutions";
import { CoreServicesGrid } from "../components/sections/CoreServicesGrid";
import { ProcessTimeline } from "../components/sections/ProcessTimeline";
import { FinalCTA } from "../components/sections/FinalCTA";
import { images } from "../data/content";

export default function ManpowerSolutionsPage() {
    return (
        <>
            <PageHero
                overline="Manpower Solutions"
                breadcrumb="Manpower"
                title="Manpower for Every Business Requirement"
                subtitle="Unskilled, semi-skilled and skilled professional workforce — scalable to any volume and deployable across India."
                image={images.warehouse}
            />
            <ManpowerSolutions dark={false} />
            <CoreServicesGrid dark />
            <ProcessTimeline />
            <FinalCTA />
        </>
    );
}
